import { memo } from 'react'

import { Link, Text } from '@cash-me/react-components'

export const PrivacyNotice = memo(() => (
  <Text size="caption" weight="medium" color="var(--colors-neutral-text-weak)">
    Utilizaremos seus dados pessoais para atendermos a sua solicitação. Para maiores informações sobre como tratamos
    seus dados, acesse nosso{' '}
    <Link href="https://www.cashme.com.br/aviso-de-privacidade/" inline target="_blank">
      Aviso de Privacidade.
    </Link>
  </Text>
))

PrivacyNotice.displayName = 'PrivacyNotice'
